import React from 'react'
import PropTypes from 'prop-types'
import PhoneLoginModal from '../block/PhoneLoginModal'

class WelcomeLogin extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showPhoneModal: false
    }
  }

  handleOpenPhoneModal = () => {
    this.setState({ showPhoneModal: true })
  }

  handleClosePhoneModal = () => {
    this.setState({ showPhoneModal: false })
  }

  handlePhoneSubmit = (phone) => {
    console.log('Phone submitted:', phone)
    // Здесь будет логика отправки номера телефона
    this.handleClosePhoneModal()
  }

  render() {
    const { assets_path, token, showFeedbackForm, host } = this.props
    const { showPhoneModal } = this.state
    
    return (
      <>
        <div 
          className="fixed inset-0 -z-10 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(/${assets_path}/images/welcome_login_bg.svg)`
          }}
        />
        <div className='fixed top-0 left-0 bottom-0 right-0 flex items-end'>
          <div className="container px-0 font-manrope relative flex items-end">
            <div
              className="w-full"
              style={{
                minHeight: '238px',
                borderRadius: '0px',
                borderTopLeftRadius: '25px',
                borderTopRightRadius: '25px',
                backdropFilter: 'blur(37px)',
                paddingTop: '20px',
                paddingBottom: '25px',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                border: 'none'
              }}
            >
              <div className="flex flex-col items-center">
                <div className="mb-2">
                  <img
                    src={`/${assets_path}/images/start_logo.svg`}
                    alt="okidoki"
                    width={119}
                    height={49}
                  />
                </div>

                <div className="text-center mb-5">
                  <div className="text-white font-semibold text-center text-[24px] mb-[5px]" style={{ color: 'white', margin: 0 }}>
                    Войдите в профиль<br />
                  </div>

                  <div className="text-white/60 text-center block text-[14px]">
                    Чтобы копить оки-коины и заказывать вкусную еду
                  </div>
                </div>

                <button
                  className="w-[345px] max-w-[90%] h-10 rounded-full mb-2 bg-[#FF6B35] hover:bg-[#e55a2b] text-white font-inter text-[16px] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={this.handleOpenPhoneModal}
                  disabled={token == ``}
                >
                  Поехали!
                </button>

                <div className="text-white/60 text-center m-0 text-[14px]">
                  Нажимая на кнопку «Поехали», вы соглашаетесь<br />
                  с <a href="/politika" className="text-white underline">Политикой конфиденциальности</a>
                </div>
              </div>
            </div>

          </div>
        </div>
        <PhoneLoginModal
          assets_path={assets_path}
          visible={showPhoneModal}
          onClose={this.handleClosePhoneModal}
          onSubmit={this.handlePhoneSubmit}
          token={token}
          showFeedbackForm={showFeedbackForm}
          host={host}
        />
      </>
    )
  }
}

WelcomeLogin.propTypes = {
  assets_path: PropTypes.string,
  token: PropTypes.string,
  showFeedbackForm: PropTypes.func,
  host: PropTypes.string
}

export default WelcomeLogin